
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import immediateAnnuityPlanScenariosQuery from '~/apollo/queries/product/immediateAnnuityPlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import immediateAnnuityTooltips from '~/apollo/queries/product/tooltips/immediateAnnuityTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsImmediateAnnuityListingPage',
  mixins: [commonProductMixins, productPromotionMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    annuityPlanScenarios: {
      query: gql`
        ${immediateAnnuityPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;
        let tmpIncomeTerm;
        tmpIncomeTerm = undefined;
        let tmpLocale;
        tmpLocale = undefined;
        let tmpIncomeTermEndFrom;
        tmpIncomeTermEndFrom = undefined;
        let tmpIncomeTermEndTo;
        tmpIncomeTermEndTo = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        // if (this.filter.incomeTermValue?.value !== '-1') {
        //   tmpIncomeTerm = parseInt(this.filter.incomeTermValue?.value);
        // }
        if (this.filter.incomeTermValue?.value === '85-99') {
          tmpIncomeTermEndFrom = 85;
          tmpIncomeTermEndTo = 99;
        } else if (this.filter.incomeTermValue?.value === '100') {
          tmpIncomeTermEndFrom = 100;
        }

        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        return {
          insCompCode: tmpComp,
          // income_term: tmpIncomeTerm,
          income_term_end_from: tmpIncomeTermEndFrom,
          income_term_end_to: tmpIncomeTermEndTo,
          currency: parseInt(this.filter.currencyValue?.value),
          locale: tmpLocale,
          age: parseInt(this.filter.issueAgeValue?.value),
          // total_premium: parseFloat(this.filter.totalPremiumValue[this.filter.currencyValue[this.filter.objectiveValue]][this.filter.objectiveValue])
        };
      },
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return { show_annuity: true };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },
    immediateAnnuityTooltips: {
      query: immediateAnnuityTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),

      filter: {
        insCompValue: [],

        currencyValue: { value: this.$route.query.currency ? this.$route.query.currency : '2', text: '' },
        currencyOptions: [
          { value: '1', text: 'USD' },
          { value: '2', text: 'HKD' },
        ],

        incomeTermValue: {
          value: this.$route.query.income_term ? this.$route.query.income_term : '-1',
          text: this.$t('products.any'),
        },
        incomeTermOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: '85-99', text: this.$t('products.annuity.ai_incomeTermEnd8599').replace('$fromNum', '85').replace('$toNum', '99') },
          { value: '100', text: this.$t('products.annuity.ai_incomeTermEnd100') }
      ],
        // incomeTermOptions: [
        //   { value: '-1', text: this.$t('products.any') },
        //   { value: '18', text: '18' + this.$t('products.yearsUnit') },
        //   { value: '25', text: '25' + this.$t('products.yearsUnit') },
        //   { value: '30', text: '30' + this.$t('products.yearsUnit') },
        //   { value: '34', text: '34' + this.$t('products.yearsUnit') },
        //   { value: '85', text: '85' + this.$t('products.yearsUnit') },
        //   { value: '99', text: this.$t('products.annuity.ai_wholelife') },
        // ],

        issueAgeValue: {
          value: this.$route.query.issue_age ? this.$route.query.issue_age : '65',
          text: '65'
        },
        issueAgeOptions: [
          { value: '60', text: '60' },
          { value: '65', text: '65' },
        ],

        totalPremiumValue: {
          1: {
            value: this.$route.query.total_premium ? this.$route.query.total_premium : '125000',
            text: 'USD 125,000',
          },
          2: { value: '1000000', text: 'HKD 1,000,000' },
        },
        totalPremiumOptions: {
          1: [{ value: '125000', text: 'USD 125,000' }],
          2: [{ value: '1000000', text: 'HKD 1,000,000' }],
        },
      },
      perPage: 15,
      currentPage: 1,
      annuityPlanScenarios: null,
      insuranceCompanies: null,

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'five_star', text: '' },
        sortingOptions: [
          { value: 'five_star', text: this.$t('products.annuity.ai_5StarRatings') },
          { value: 'score', text: this.$t('products.annuity.ai_immediateAnnuityScore') },
          { value: 'g_irr', text: this.$t('products.annuity.ai_guaranteedIRRatAge85') },
          { value: 'g_income_yearone', text: this.$t('products.annuity.ai_guaranteedInitialAnnualIncomeHightoLow') },
          { value: 'p_income_yearone', text: this.$t('products.annuity.ai_projectedInitialAnnualIncomeHightoLow') },
        ],
      },
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.annuityPlanScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.annuity.ai_result').replace('$num', '{ }');
      } else {
        // below translation hasn't implemented yet..
        return this.$t('products.annuity.ai_result').replace('$num', this.rows);
      }
    },

    displayProducts() {
      return this.sortedItem?.map((item) => ({
        id: item.scenario_code,
        category: this.category,
        scenarioId: item.scenarioID,
        showFiveStarBadge: item.overall_star_immediate,
        showTrending: false,

        productLink: this.$extendPath(this.$route.path, '/' + item.scenario_code),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: this.$formatScore(item.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score),
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: parseFloat(item.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score),
          description: this.$t('products.annuity.ai_immediateAnnuityScore'),
          toolTipHtml: this.getTooltipContentByKey('ai_immediateAnnuityScore'),
        },
        features: [
          {
            text:
              item.premium_term === 1
                ? this.$t('products.annuity.ai_singlePremium')
                : item.premium_term + this.$t('products.yearPremium'),
            type: 'payment_term',
          },
          {
            text:
              this.$formatAge(this.currentLocale, item.income_term_start, this.$t('products.ageUnit')) +
              this.$t('products.annuity.as_annuityStart'),
            type: 'annuity_start_age',
          },
          {
            text: item.income_term_end === 999
              ? this.$t('products.annuity.ai_wholelife') 
              : this.$t('products.annuity.ai_incomeTermEnd').replace('$num', item.income_term_end),
            type: 'income_term',
          },
          // {
          //   text:
          //     item.income_term === 99
          //       ? this.$t('products.annuity.ai_wholelife')
          //       : item.income_term + this.$t('products.yearAnnuity'),
          //   type: 'income_term',
          // },
        ],
        keyItems: [
          {
            value: this.$formatPercentageDP(item.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr, 1),
            key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('ai_guaranteedAnnuityInternalRateofReturnIRR'),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true,
          },
          {
            value: this.$formatPrice(item.g_initial_annual_income_immediate_annuity),
            key: this.$t('products.annuity.ai_guaranteedInitialAnnualIncome'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
          },
          {
            value: this.$formatPrice(item.p_initial_annual_income_immediate_annuity),
            key: this.$t('products.annuity.ai_projectedInitialAnnualIncome'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
          },
        ],
        mobileKeyItems: [
          {
            value: this.$formatPercentageDP(item.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr, 1),
            key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('ai_guaranteedAnnuityInternalRateofReturnIRR'),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true,
          },
          {
            value: this.$formatPrice(item.g_initial_annual_income_immediate_annuity),
            key: this.$t('products.annuity.ai_guaranteedInitialAnnualIncome'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
            isTextBold: true,
          },
          {
            value: this.$formatPrice(item.p_initial_annual_income_immediate_annuity),
            key: this.$t('products.annuity.ai_projectedInitialAnnualIncome'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
            isTextBold: true,
          },
        ],
        compactKeyItems: [
          {
            value: this.$formatPrice(item.g_initial_annual_income_immediate_annuity),
            key: this.$t('products.annuity.ai_guaranteedInitialAnnualIncome'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
            isTextBold: true,
          },
          {
            value: this.$formatPercentageDP(item.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr, 1),
            key: this.$t('products.annuity.ai_guaranteedIRRatAge85'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: true,
          },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          lastCall: item.promotion_last_call

        },
        mainButtonCTA: item.main_cta,
        price: {
          originalPrice: '',
          discountPrice: '',
          prefix: '',
          postfix: '',
          subText: '',
          toolTipHtml: '',
        },
      }));
    },

    rows() {
      if (this.simpleItems) {
        return this.simpleItems.length;
      }
      return 0;
    },

    sortedItem() {
      if (this.sortingData.sortValue.value === 'five_star') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
              b.overall_star_immediate - a.overall_star_immediate ||
                b.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score - a.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score ||
                b.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr -
                  a.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr ||
                b.g_initial_annual_income_immediate_annuity - a.g_initial_annual_income_immediate_annuity ||
                b.p_initial_annual_income_immediate_annuity - a.p_initial_annual_income_immediate_annuity
            );
        }
      } 
      else if (this.sortingData.sortValue.value === 'score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
              b.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score - a.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score ||
              b.overall_star_immediate - a.overall_star_immediate ||
                b.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr -
                  a.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr ||
                b.g_initial_annual_income_immediate_annuity - a.g_initial_annual_income_immediate_annuity ||
                b.p_initial_annual_income_immediate_annuity - a.p_initial_annual_income_immediate_annuity
            );
        }
      } else if (this.sortingData.sortValue.value === 'g_irr') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
              b.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr -
                a.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr ||
              b.overall_star_immediate - a.overall_star_immediate ||
                b.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score - a.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score ||
                b.g_initial_annual_income_immediate_annuity - a.g_initial_annual_income_immediate_annuity ||
                b.p_initial_annual_income_immediate_annuity - a.p_initial_annual_income_immediate_annuity
            );
        }
      } else if (this.sortingData.sortValue.value === 'g_income_yearone') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
              b.g_initial_annual_income_immediate_annuity - a.g_initial_annual_income_immediate_annuity ||
              b.overall_star_immediate - a.overall_star_immediate ||
                b.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score - a.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score ||
                b.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr -
                  a.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr ||
                b.p_initial_annual_income_immediate_annuity - a.p_initial_annual_income_immediate_annuity
            );
        }
      } else if (this.sortingData.sortValue.value === 'p_income_yearone') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
              b.p_initial_annual_income_immediate_annuity - a.p_initial_annual_income_immediate_annuity ||
              b.overall_star_immediate - a.overall_star_immediate ||
                b.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score - a.immediate_annuity_result[0]?.attributes?.immediate_total_overall_score ||
                b.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr -
                  a.immediate_annuity_result_85[0]?.attributes?.death_discounted_non_tax_s_girr ||
                b.g_initial_annual_income_immediate_annuity - a.g_initial_annual_income_immediate_annuity
            );
        }
      }
      return null;
    },

    simpleItems() {
      if (this.annuityPlanScenarios) {
        return this.annuityPlanScenarios.data.map((item) => {
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName =
            item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
          let decoderCTALink = '';
          let decoderCTAText = '';

          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          // check scenario level promo first , then plan level promotion 
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.annuity_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.annuity_plan.data.attributes.product_promotions.data;
          }
          
          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
              decoderCTAText = this.$t('products.product_website');

              mainCTA = this.getDecoderCTA(item, decoderCTALink)
            }
          }

          const immediate_annuity_result = item.attributes.annuity_plan_financial_details.data.filter(
            (fd) => {
                  if (item.attributes.income_term_end < 105 && item.attributes.income_term_end !== -1) {
                    return fd.attributes.age === item.attributes.income_term_end;
                  }
                  return fd.attributes.age === 105;
                }
          )
          // const immediate_annuity_result = item.attributes.annuity_plan_financial_details.data.filter(
          //   (fd) => fd.attributes.age === item.attributes.income_term_start
          // )

          const immediate_annuity_result_85 = item.attributes.annuity_plan_financial_details.data.filter(
            (fd) => fd.attributes.age === 85
          )



          const filteredTranslations = this.getFilteredTranslations(item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            plan_code: item.attributes.annuity_plan.data.attributes.plan_code,
            scenario_code: item.attributes.scenario_code,
            g_income_yearone: item.attributes.g_income_yearone,
            p_income_yearone_base: item.attributes.p_income_yearone_base,
            premium_term: item.attributes.premium_term,
            income_term_start: item.attributes.income_term_start,
            income_term_end: item.attributes.income_term_end,
            income_term: item.attributes.income_term,
            overall_star_immediate: immediate_annuity_result[0]?.attributes.overall_star_immediate,
            gbey: item.attributes.gbey,
            currency_code: item.attributes.currency.data.attributes.code,

            // // plan
            plan_name: planName,

            // // insurer
            insurer_name_first:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo,
            insurer_code:
              item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,

            // financial details
            longevity_result: item.attributes.annuity_plan_financial_details.data.filter(
              (item) => item.attributes.age === 85
            ),
            immediate_annuity_result,
            immediate_annuity_result_85,
            product_promotion: promotion,
            promotion_last_call: promotion_last_call,

            decoder_cta_link: decoderCTALink,
            decoder_cta_text: decoderCTAText,

            scenarioID: item.id,

            main_cta: mainCTA,

            g_initial_annual_income_immediate_annuity: (immediate_annuity_result[0]?.attributes?.initial_income_gcv / item?.attributes.total_premium)*item?.attributes.tpp_display ,
            p_initial_annual_income_immediate_annuity: (immediate_annuity_result[0]?.attributes?.initial_income_tot / item?.attributes.total_premium)*item?.attributes.tpp_display ,

          };
        });
      }
      return null;
    },

    totalPremiumDefaultValue() {
      return this.filter.currencyValue.value === '1' ? '125000' : '1000000';
    },

    filterTotalPremiumActaulValue() {
      return this.filter.totalPremiumValue[this.filter.currencyValue.value];
    },

    filterTotalPremiumOptions() {
      return this.filter.totalPremiumOptions[this.filter.currencyValue.value];
    },

    filterIssueAgeActualValue() {
      return this.filter.issueAgeValue[this.filter.issueAgeValue?.value];
    },

    filterIssueAgeOptions() {
      return this.filter.issueAgeOptions[this.filter.issueAgeValue?.value];
    },

    dependentFilterValues() {
      return `${this.filter.currencyValue.value}|${this.filterTotalPremiumActaulValue.value}`;
    },
    slug() {
      return 'annuity'
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  watch: {
    dependentFilterValues() {
      this.updateDependentFilterQuerystrings();
    },
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.incomeTermValue',
        filterOptionsPath: 'filter.incomeTermOptions',
        queryKey: 'income_term',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'filter.issueAgeValue',
        filterOptionsPath: 'filter.issueAgeOptions',
        queryKey: 'issue_age',
        defaultValue: '65',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'five_star',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);

    const currencyFilter = {
      filterValuePath: 'filter.currencyValue',
      filterOptionsPath: 'filter.currencyOptions',
      queryKey: 'currency',
      defaultValue: '2',
    };
    this.fixFilterValue(currencyFilter);
    this.createQueryStringWatcher(currencyFilter);

    const fixTotalPremiumValue = () => {
      const options = this.$_.get(this, 'filterTotalPremiumOptions');
      const actualValue = this.$_.get(this, 'filterTotalPremiumActaulValue' + '.value');
      const foundOption = this.locateFilterOption(actualValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.totalPremiumValue[' + this.filter.currencyValue.value + ']',
          this.locateFilterOption(actualValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.totalPremiumValue[' + this.filter.currencyValue.value + ']',
          this.locateFilterOption(this.totalPremiumDefaultValue, options)
        );
      }
    };
    fixTotalPremiumValue();

    this.$watch('$route.query.' + 'total_premium', (newValue) => {
      const mValue = newValue === undefined || newValue === null ? this.totalPremiumDefaultValue : newValue;
      const options = this.$_.get(this, 'filterTotalPremiumOptions');
      const foundOption = this.locateFilterOption(mValue, options);
      if (foundOption) {
        this.$_.set(
          this,
          'filter.totalPremiumValue[' + this.filter.currencyValue.value + ']',
          this.locateFilterOption(mValue, options)
        );
      } else {
        this.$_.set(
          this,
          'filter.totalPremiumValue[' + this.filter.currencyValue.value + ']',
          this.locateFilterOption(this.totalPremiumDefaultValue, options)
        );
      }
    });
    this.$watch('$route.query.' + 'issue_age', (newValue) => {
      const mValue = newValue === undefined || newValue === null ? '65' : newValue;
      this.$_.set(this, 'filter.issueAgeValue', { value: mValue, text: mValue });
    });
  },

  mounted() {
    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };
    this.$nextTick(() => {
      console.log('simpleItems', this.simpleItems);
    });

    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {
    updateDependentFilterQuerystrings() {
      const removeKeys = [];
      const extendKeys = [];

      if (this.filter.currencyValue.value === '2') {
        removeKeys.push('currency');
      } else {
        extendKeys.push({ currency: this.filter.currencyValue.value });
      }

      if (this.filterTotalPremiumActaulValue.value === this.totalPremiumDefaultValue) {
        removeKeys.push('total_premium');
      } else {
        extendKeys.push({ total_premium: this.filterTotalPremiumActaulValue.value });
      }

      const combineQuery = Object.assign({}, this.$route?.query, ...extendKeys);
      const changedQuery = this.$_.omit(combineQuery, removeKeys);
      const sortedQuery = Object.keys(changedQuery)
        .sort()
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: combineQuery[key],
          }),
          {}
        );
      this.updateQueryString(sortedQuery);
    },

    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.annuity.ai_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.annuity_plan.data.attributes.saleable;
      const productWebsite = item.attributes.annuity_plan.data.attributes.annuity_plan_translations.data[0].attributes.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    getTooltipContentByKey(mKey) {
      return (
        this.immediateAnnuityTooltips?.ImmediateAnnuity?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? ''
      );
    },
  },
  components: {
    QuickGuideWrapper
  }
};
